<section class="platform-businesses-business-administration">
  <div class="box">
    <div class="box-topic">
      <h3 class="box-topic__heading"
        ><span>{{ 'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.HEADING' | translate }}</span></h3
      >
      <div class="box-topic__detail">
        <span>{{ 'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.DETAIL' | translate }}</span>
      </div>
    </div>
    <div class="box-wrapper">
      <div class="box-wrapper__image">
        <a
          [href]="'https://share.hsforms.com/1CUHVmOH4RYi7AjF6183XRAchcs6?connect-with-us'"
          rel="noopener noreferrer"
          target="_blank"
        >
          <picture>
            <source
              [src]="
                'https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Register_from_connect_with_anyone.webp'
              "
              type="image/webp"
            />
            <img
              [srcset]="
                'https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Register_from_connect_with_anyone.jpg'
              "
              class="box-wrapper__image--layout"
              width="100%"
              [alt]="'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.CONTENT.1.TITLE' | translate"
              loading="lazy"
            />
          </picture>
        </a>
      </div>
      <div class="box-wrapper__content">
        <div class="box-wrapper__content--title"
          ><span>{{ 'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.CONTENT.1.TITLE' | translate }}</span></div
        >
        <div class="box-wrapper__content--detail"
          ><span>{{ 'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.CONTENT.1.DETAIL' | translate }}</span></div
        >
        <a
          class="box-wrapper__content--btn"
          [href]="'https://share.hsforms.com/1CUHVmOH4RYi7AjF6183XRAchcs6?connect-with-us'"
          rel="noopener noreferrer"
          target="_blank"
          ><span>{{ 'PLATFORM_BUSINESSES.BUSINESS_ADMINISTRATION.CONTENT.BUTTON' | translate }}</span
          ><i class="fas fa-angle-right"></i
        ></a>
      </div>
    </div>
  </div>
</section>
